import { z } from 'zod';
// ── Shared enums ──────────────────────────────────────────────────────────────
export const spanKindEnum = z.enum(['pipeline', 'agent', 'tool', 'llm', 'memory', 'atlas', 'http']);
export const spanStatusEnum = z.enum(['ok', 'error', 'cancelled']);
export const groupByEnum = z.enum(['hour', 'day', 'week']);
export const scopeTypeEnum = z.enum(['user', 'agent', 'profile', 'pipeline', 'model', 'conversation']);
export const exportFormatEnum = z.enum(['csv', 'json']);
export const anomalyScopeBreakdownEnum = z.enum(['global', 'agent', 'profile', 'pipeline']);
// ── /traces list query ────────────────────────────────────────────────────────
export const tracesListQuerySchema = z.object({
    runId: z.coerce.number().int().positive().optional(),
    agentId: z.coerce.number().int().positive().optional(),
    profileId: z.coerce.number().int().positive().optional(),
    kind: spanKindEnum.optional(),
    status: spanStatusEnum.optional(),
    fromDate: z.string().optional(),
    toDate: z.string().optional(),
    errorContains: z.string().optional(),
    name: z.string().optional(),
    tenantId: z.coerce.number().int().positive().optional(),
    /** F5-B2: filter spans by conversation (ai_conversations.id) */
    conversationId: z.coerce.number().int().positive().optional(),
    limit: z.coerce.number().int().min(1).max(200).optional().default(50),
    offset: z.coerce.number().int().min(0).optional().default(0),
});
// ── /cost query ───────────────────────────────────────────────────────────────
export const costQuerySchema = z.object({
    from: z.string(),
    to: z.string(),
    groupBy: groupByEnum.optional().default('day'),
    scopeType: scopeTypeEnum.optional(),
    userId: z.coerce.number().int().positive().optional(),
    agentId: z.coerce.number().int().positive().optional(),
    profileId: z.coerce.number().int().positive().optional(),
    pipelineId: z.coerce.number().int().positive().optional(),
    /** F5-B2: scope cost aggregation to a specific conversation */
    conversationId: z.coerce.number().int().positive().optional(),
});
// ── /anomaly/history query ────────────────────────────────────────────────────
export const anomalyHistoryQuerySchema = z.object({
    days: z.coerce.number().int().min(1).max(90).optional().default(30),
});
// ── /export/traces query ──────────────────────────────────────────────────────
export const exportTracesQuerySchema = z.object({
    from: z.string(),
    to: z.string(),
    format: exportFormatEnum.optional().default('csv'),
    kind: spanKindEnum.optional(),
    status: spanStatusEnum.optional(),
    runId: z.coerce.number().int().positive().optional(),
    agentId: z.coerce.number().int().positive().optional(),
    profileId: z.coerce.number().int().positive().optional(),
    errorContains: z.string().optional(),
});
// ── /export/cost query ────────────────────────────────────────────────────────
export const exportCostQuerySchema = z.object({
    from: z.string(),
    to: z.string(),
    format: exportFormatEnum.optional().default('csv'),
    scopeType: scopeTypeEnum.optional(),
});
// ── /cache-hit query (F5-B3 — roadmap #38) ────────────────────────────────────
export const cacheHitQuerySchema = z.object({
    days: z.coerce.number().int().min(1).max(90).optional().default(7),
});
//# sourceMappingURL=observability.schema.js.map